import Base from "@/controllers/base";
import SignaturePad from "signature_pad";
export default class Signature extends Base {
  constructor(elem) {
    super(elem);
    this.canvas = null;
    this.pad = null;
    this.form = this.elem.querySelector("form#sform");
  }

  init() {
    super.init();
    this.buildPad();
  }

  async buildPad() {
    try {
      this.canvas = document.querySelector("canvas");
      if (this.canvas) {
        this.pad = new SignaturePad(this.canvas, {
          minWidth: 2,
          maxWidth: 5,
          throttle: 16,
        });
        this.resizeCanvas();
        const name = this.canvas.dataset.name;
        if (name) {
          const response = await fetch(`/cached_signatures/${name}`);
          const result = await response.json();
          if (result.data) {
            this.pad.fromDataURL(result.data);
          }
        }
        window.addEventListener("resize", this.resizeCanvas);
      }
    } catch (ex) {
      console.error(ex);
    }
  }

  resizeCanvas() {
    if (this.canvas) {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      this.canvas.width = this.canvas.offsetWidth * ratio;
      this.canvas.height = this.canvas.offsetHeight * ratio;
      return this.canvas.getContext("2d").scale(ratio, ratio);
    }
  }

  clear() {
    this.pad.clear();
  }

  sign() {
    if (this.pad.isEmpty()) {
      this.form.querySelector("#sdata").value = "";
      alert("Please sign before saving signature");
    } else {
      this.form.querySelector("#sdata").value = this.pad.toDataURL();
      if (this.form.checkValidity()) {
        this.elem.querySelector(".m-signature-pad-footer").innerHTML =
          "<center class='red f120'>Applying your signature to document now. Please wait...</center>";
        let div = document.createElement("div");
        div.classList.add("full-spinner");
        document.body.appendChild(div);
        this.form.submit();
      } else {
        this.form.reportValidity();
      }
    }
  }

  static syncDate(input) {
    document.querySelector("form#sform input#sdate").value = input.value;
  }
}
